import { createSlice } from '@reduxjs/toolkit';
import { lookupProviderByIdApi } from '../../../rtk-apis/hl7/lookupProviderById';

const initialState = {
  status: '',
  result: null as any,
  msg: '',
  loading: false,
};

const lookupProviderByIdSlice = createSlice({
  name: 'lookupProviderById',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(lookupProviderByIdApi.pending, state => {
        state.loading = true;
      })
      .addCase(lookupProviderByIdApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action.payload;
        state.msg = action.payload?.msg || '';
      })
      .addCase(lookupProviderByIdApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = (action.payload as string) || 'Lookup failed';
      });
  },
});

export const { clearState: clearLookupProviderByIdState } = lookupProviderByIdSlice.actions;
export default lookupProviderByIdSlice.reducer;
